import React from 'react';

const accessPoints = [
  {
    category: 'Ceiling Mount Access Points',
    items: [
      'Edgecore EAP102 — Dual-band, 4x4:4 MU-MIMO, 802.11ax (WiFi 6)',
      'CIG / Actiontec WF-196 — Tri-band, 4x4 MU-MIMO, 802.11ax (WiFi 6E)'
    ]
  },
  {
    category: 'Wall Plate Access Points',
    items: [
      'Edgecore EAP104 — Dual-band, 2x2:2 MU-MIMO, 802.11ax (WiFi 6)',
      'CIG / Actiontec WF-186W — Dual-band, 2x2:2 MU-MIMO, 802.11ax (WiFi 6)'
    ]
  },
  {
    category: 'Outdoor Access Points',
    items: [
      'Edgecore OAP101-6E — Tri-band, 2x2:2 MU-MIMO, 802.11ax (WiFi 6E)',
      'CIG / Actiontec WF-660AG — Dual-band, 2x2:2 MU-MIMO, 802.11ax (WiFi 6)'
    ]
  }
];

const switches = [
  'Edgecore ECS1100-10HP — 8 x 1 Gbps (PoE), 802.3bt, 250W PoE budget',
  'Edgecore ECS4150-28P — 24 x 1 Gbps (PoE), 4 x 10G SFP+ uplinks, af/at/bt',
  'Edgecore ECS4150-54P — 48 x 1 Gbps (PoE), 6 x 25G SFP28 uplinks, 740W PoE budget'
];

const OpenHardware = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Open Hardware</h1>

        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Sarvanta supports an expansive portfolio of access points and PoE switches. Combined
          with cloud-native management, zero-touch provisioning, and a disaggregated architecture,
          this approach delivers significant reductions in both initial deployment costs (CapEx) and
          ongoing operational expenses (OpEx).
        </p>

        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '40px', fontSize: '1.1rem' }}>
          By decoupling hardware from software, organizations avoid vendor lock-in and gain the
          flexibility to deploy access points from multiple manufacturers. This multi-vendor
          strategy ensures competitive pricing and future-proofs your infrastructure investment.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '24px' }}>Supported Access Points</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '40px' }}>
          {accessPoints.map((cat, i) => (
            <div key={i} style={{
              padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px',
              border: '1px solid #1a2744'
            }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '12px', color: '#60a5fa' }}>{cat.category}</h3>
              <ul style={{ color: '#a0aec0', lineHeight: '2', paddingLeft: '20px', margin: 0 }}>
                {cat.items.map((item, j) => <li key={j}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '24px' }}>Managed PoE Switches</h2>
        <div style={{
          padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px',
          border: '1px solid #1a2744'
        }}>
          <p style={{ color: '#a0aec0', marginBottom: '12px' }}>
            Sarvanta supports the following openLAN Switching-compliant managed switches:
          </p>
          <ul style={{ color: '#a0aec0', lineHeight: '2', paddingLeft: '20px', margin: 0 }}>
            {switches.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OpenHardware;
